import { useState, useEffect } from 'react';

function computeTarget(sendHourUtc: number, sendMinuteUtc: number): Date | null {
  const now = new Date();
  const target = new Date(now);
  target.setUTCHours(sendHourUtc, sendMinuteUtc, 0, 0);
  return target.getTime() > now.getTime() ? target : null;
}

export const useAutoSendTime = (
  sendHourUtc: number,
  sendMinuteUtc: number,
): Date | null => {
  const [target, setTarget] = useState<Date | null>(() =>
    computeTarget(sendHourUtc, sendMinuteUtc),
  );

  useEffect(() => {
    setTarget(computeTarget(sendHourUtc, sendMinuteUtc));
    const interval = setInterval(() => {
      setTarget(computeTarget(sendHourUtc, sendMinuteUtc));
    }, 10_000);
    return () => clearInterval(interval);
  }, [sendHourUtc, sendMinuteUtc]);

  return target;
};
